import { stringify } from "graphql/mutations/selectData";
import { useClientFetchOnly } from "./useFetch";

export function useHasModuleAccess(Module = "studio", tier = "regular") {
    const { accessedModules, ...profile } = useClientFetchOnly("Profile") || {};
    const hasModule = stringify(0, accessedModules || []).includes(Module);
    const hasAccessTier = stringify(0, accessedModules || []).includes(tier);
    return [hasModule, { accessedModules, ...profile }, hasAccessTier];
  }